module.exports = {
	"articleTitle1": "Motor City's Guggenheim: Finding the energy of Detroit on ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Heidelberg",
	"totalMisc": 0,
	"articleLink2": "https://www.michigandaily.com/section/arts/30-year-anniversary-tyree-guyton%E2%80%99s-heidelberg-project-celebrated-umma-copy",
	"articleSnippet1": "Feb 15, 2017 ... The future of Detroit is in projects like Heidelberg; in the way it serves to both heal \nand elevate the surrounding communities.",
	"articleSnippet2": "Oct 14, 2015 ... 2016 marks the 30th anniversary of Tyree Guyton's site-specific art installation on \nthe east side of Detroit, The Heidelberg Project, and everyone ...",
	"articleLink1": "https://www.michigandaily.com/section/arts/ghetto-guggenheim-finding-energy-detroit-heidelberg-street",
	"articleTitle2": "Make It Greater: The Heidelberg Project's 30-year legacy ",
	"address": "215 N Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.282893,
		"lng": -83.74881
	},
	"foodRecommendations": [
		{
			"text": "It's a cool bar with cool architecture. They have das boot there.",
			"person": "Charlie Ruiz"
		}
	],
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/heidelberg.json
// module id = 888
// module chunks = 0